import React from 'react';
import cx from 'classnames';

import type { CartItemType } from '@zola-helpers/client/dist/es/@types/cart';
import styles from './cartItemSubTotal.module.less';
import { compactCurrencyFilter } from '../utils/PricingUtils';

export const CartItemSubTotal = ({
  item,
  className,
}: {
  item: CartItemType;
  className?: string;
}) => {
  return (
    <div className={cx(styles.cartItemSubTotal, className)}>
      {compactCurrencyFilter(item.subtotal)}
    </div>
  );
};
